const warningIcon = {
  iconName: 'Warning',
  styles: {
    root: {
      color: '#FFB900',
      fontSize: '20px',
      padding: '5px',
      backgroundColor: 'none',
    },
  },
};

const infoIcon = {
  iconName: 'Error',
  styles: {
    root: {
      fontSize: '20px',
      padding: '5px',
      backgroundColor: 'none',
    },
  },
};

const criticalErrorIcon = {
  iconName: 'ErrorBadge',
  styles: {
    root: {
      color: '#E0181A',
      fontSize: '20px',
      padding: '5px',
      backgroundColor: 'none',
    },
  },
};

const blockedIcon = {
  iconName: 'Blocked',
  styles: {
    root: {
      color: '#E0181A',
      fontSize: '20px',
      padding: '5px',
      backgroundColor: 'none',
    },
  },
};

export const getIcon = (type: string) => {
  switch (type.toLowerCase()) {
    case 'warning':
      return warningIcon;
    case 'info':
      return infoIcon;
    case 'error':
      return criticalErrorIcon;
    case 'critical':
      return blockedIcon;
    default:
      return infoIcon;
  }
};
